import { render, staticRenderFns } from "./TopInfo-mobile.vue?vue&type=template&id=2b629c34&scoped=true"
import script from "./TopInfo-mobile.vue?vue&type=script&lang=js"
export * from "./TopInfo-mobile.vue?vue&type=script&lang=js"
import style0 from "./TopInfo-mobile.vue?vue&type=style&index=0&id=2b629c34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b629c34",
  null
  
)

export default component.exports